exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/node_modules/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!/Users/dominik/Documents/projekty/guru-monarch-beach-resort/guru-monarch-beach-resort/src/styles.scss
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.scss
// module chunks = styles